import _ from "lodash";
import React from "react";
import {
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  DP_ASSESSMENT_RUBRIC,
  SCORE,
  COMMENT,
  RUBRIC,
  SINGLE_POINT_RUBRIC,
  CHECKLIST,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
} from "Constants/stringConstants";
import {
  PencilOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from "@toddle-edu/ds-icons";
import ACLStore from "lib/aclStore";

export const TOOLS_WITH_ONLY_TEACHER_EVALUATION = [
  COMMENT,
  SCORE,
  DP_ASSESSMENT_RUBRIC,
  ASSESSMENT_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
];

export const COLLAPSIBLE_TOOLS = [
  RUBRIC,
  SINGLE_POINT_RUBRIC,
  CHECKLIST,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
  DP_ASSESSMENT_RUBRIC,
  ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY,
  ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
];

// tools with just delete button
export const INLINE_TOOLS = [
  SCORE,
  COMMENT,
  ASSESSMENT_GRADE_BOUNDARY,
  GRADE_SCALE_TOOL,
];

export const TOOLS_WITH_TASK_WEIGHT = [
  SCORE,
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
];

export const getDropdownOptions = params => {
  const { t, type, assessmentTools, canPrint, canEdit = true } = params;

  const options = [];
  const isPrintEnabled = !ACLStore.can(
    "FeatureFlag:PreventPrintAndScreenshots"
  );

  if (canEdit) {
    options.push({
      key: "edit_tool",
      label: t("common:edit"),
      icon: <PencilOutlined />,
    });
  }

  if (type === "DP_ASSESSMENT_RUBRIC") {
    const dpRubric = _.find(assessmentTools, ({ node }) => {
      return _.get(node, "assessmentToolType") === type;
    });

    const isDPRubricGlobal = _.get(
      dpRubric,
      "node.assessmentToolItem.isGlobal",
      true
    );

    if (isDPRubricGlobal) {
      options.splice(options.indexOf("edit_tool"), 1);
    }
  }

  if (canPrint && isPrintEnabled) {
    options.push({
      key: "download_tool",
      label: t("common:download"),
      icon: <DownloadOutlined />,
    });
  }

  options.push({
    key: "remove_tool",
    label: t("common:remove"),
    icon: <DeleteOutlined />,
    isDestructive: true,
  });

  return options;
};

export const getEvaluationText = params => {
  const { t, isTeacherEvaluationEnabled, isStudentEvaluationEnabled } = params;

  if (isTeacherEvaluationEnabled && isStudentEvaluationEnabled) {
    return t("classRoom:enabled_with_label", {
      label: t("classRoom:teacher_and_student_eval"),
    });
  } else if (isTeacherEvaluationEnabled) {
    return t("classRoom:enabled_with_label", {
      label: t("common:teacher_evaluation"),
    });
  } else if (isStudentEvaluationEnabled) {
    return t("classRoom:enabled_with_label", {
      label: t("common:student_evaluation"),
    });
  } else {
    return null;
  }
};

export const DIALOGUES_INFO = {
  SAVE_TEMPLATE: {
    title: ({ t, label }) =>
      t("common:save_this_template_with_label", {
        label,
      }),
    message: t => t("common:dicard_the_changes_warning_msg"),
    confirmButtonText: t => t("common:add"),
    cancelButtonText: t => t("common:cancel"),
  },
};
